<!-- <div class="col-md-12">
  <div *ngIf="loader">
    <div class="d-flex justify-content-center" style="color: #fbb416;">
      <app-common-icon [loadingIcon]="loader"></app-common-icon>
    </div>
  </div>

  <div class="card mb-3" *ngFor="let enquiry of allList">
    <div class="row g-0">
      <div class="col-md-4 image-wraper">
      <div  class="image">
        <ng-container *ngIf="enquiry?.user?.profileUrl?.objectUrl; else nameInitial">
          <img [src]="enquiry?.user?.profileUrl?.objectUrl">
        </ng-container>
        <ng-template #nameInitial>
          <div class="name-initial"> {{ getInitials(enquiry?.user?.name) || "-"}}</div>
        </ng-template>
        <p class="name">{{enquiry?.user?.name}}</p>
        <p class="mobile">+91-{{enquiry?.phoneNumber}}</p>
      </div>
    </div>
      <div class="col-md-8">
        <div class="card-data-block">
          <p class="card-text card-projectname text-warning">{{enquiry?.propertyId?.projectName}}</p>
          <p class="card-text">{{enquiry?.created | date:"dd MMM yy" }}</p>
        </div>
        <div class="row">
          <p class="card-text card-message">{{enquiry?.message}}</p>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!loader && allList?.length === 0">
    <div class="pt-3 text-danger d-flex justify-content-center">
      No List Found!
    </div>
  </div>
</div> -->



<div class="container-fluid">
  <div class="row g-3 justify-content-center responsive-cards">
    <div *ngIf="loader">
      <div class="d-flex justify-content-center" style="color: #fbb416;">
        <app-common-icon [loadingIcon]="loader"></app-common-icon>
      </div>
    </div>

    <div class="col-12 col-md-6"  *ngFor="let enquiry of allList">
   <div class="card h-100" style="width: 100%; max-width: 100%; height: 300px; border-radius: 10px; overflow: hidden;"
     >
      <div class="row g-0 h-100">

        <!-- Left Side -->
    <div class="col-4 d-flex flex-column justify-content-center align-items-center bg-light text-center p-2">
  <ng-container *ngIf="enquiry?.user?.profileUrl?.objectUrl; else nameInitial">
    <img [src]="enquiry?.user?.profileUrl?.objectUrl" class="user-image rounded-circle mb-2" alt="User Profile">
  </ng-container>

  <ng-template #nameInitial>
    <div class="name-initial rounded-circle mb-2 d-flex justify-content-center align-items-center">
      {{ getInitials(enquiry?.user?.name) || "-" }}
    </div>
  </ng-template>

  <h6 class="name mb-1 text-truncate user-name">{{ enquiry?.user?.name }}</h6>
  <p class="mobile mb-0 text-muted small user-phone">+91-{{ enquiry?.phoneNumber }}</p>
</div>


        <!-- Right Side -->
        <div class="col-8 p-3 d-flex flex-column justify-content-between">
          <div>
            <div class="property-header d-flex justify-content-between align-items-start mb-1">
              <h6 class="mb-0 text-truncate property-title ">{{enquiry?.propertyId?.projectName}}</h6>
              <small class="text-muted">{{enquiry?.created | date:"dd MMM yy" }}</small>
            </div>

            <p class="text-muted small mb-0" style="max-height: 120px; overflow-y: auto;">{{enquiry?.message}}
            </p>
          </div>
        </div>

      </div>
    </div>


    </div>


    <div *ngIf="!loader && allList?.length === 0">
      <div class="pt-3 text-danger d-flex justify-content-center">
        No List Found!
      </div>
    </div>
  </div>
</div>
